import { css } from "lit";

export const appStyles = css`
  :host {
    display: block;
    min-height: 100vh;
    padding: 24px 16px 48px;
    font-family:
      system-ui,
      -apple-system,
      sans-serif;
    transition:
      background 0.3s,
      color 0.3s;
  }

  .content {
    max-width: 960px;
    margin: 0 auto;
  }

  .banner-slot {
    height: 32px;
    margin-bottom: 16px;
    display: block;
    position: relative;
  }

  .layout {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .raters-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px 8px;
    margin-top: -8px;
    border-bottom: var(--bab-border-width) solid var(--bab-border);
    position: sticky;
    top: 0;
    z-index: 1;
    background: var(--bab-card-bg);
    border-radius: var(--bab-radius) var(--bab-radius) 0 0;
  }

  .raters-title {
    font-size: 0.7rem;
    font-weight: var(--bab-font-weight);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--bab-text-secondary);
  }

  .completion-badge {
    font-size: 0.7rem;
    font-weight: var(--bab-font-weight);
    color: var(--bab-text-secondary);
    transition: color 0.2s;
  }

  .completion-badge--complete {
    color: #22c55e;
  }

  .raters-panel {
    background: var(--bab-card-bg);
    border: var(--bab-border-width) solid var(--bab-border);
    border-radius: var(--bab-radius);
    box-shadow:
      0 1px 3px rgba(0, 0, 0, 0.08),
      0 4px 12px rgba(0, 0, 0, 0.04);
    overflow: clip;
    position: relative;
    padding: 12px 0;
  }

  /* Locked overlay for raters-panel */
  .raters-panel--locked::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.03);
    pointer-events: none;
    z-index: 10;
  }

  .raters-panel bab-attribute-rater {
    display: block;
    padding: 20px 16px 16px;
    border-bottom: 1px dashed var(--bab-border);
    transition: background 0.1s;

    /* Propagation */
    --bab-label-color: var(--bab-text);
    --bab-description-color: var(--bab-text-secondary);
    --bab-button-border: var(--bab-border);
    --bab-button-bg: var(--bab-card-bg);
    --bab-button-color: var(--bab-text);
    --bab-accent: var(--bab-accent);
    --bab-rating-label-color: var(--bab-text-secondary);
    --bab-border-width: var(--bab-border-width);
    --bab-radius: var(--bab-radius);
    --bab-font-weight: var(--bab-font-weight);
  }

  .raters-panel bab-attribute-rater:last-child {
    border-bottom: none;
  }

  .raters-panel bab-attribute-rater:not([disabled]):hover {
    background: var(--bab-bg);
  }

  .chart-panel {
    background: var(--bab-card-bg);
    border: var(--bab-border-width) solid var(--bab-border);
    border-radius: var(--bab-radius);
    box-shadow:
      0 1px 3px rgba(0, 0, 0, 0.08),
      0 4px 12px rgba(0, 0, 0, 0.04);
    padding: 20px;
    transition: box-shadow 0.2s;
    order: -1;
    position: relative;
  }

  .chart-panel--expanded {
    z-index: 6000;
  }

  .chart-panel:hover {
    box-shadow:
      0 2px 6px rgba(0, 0, 0, 0.1),
      0 8px 20px rgba(0, 0, 0, 0.06);
  }

  /* Desktop layout overrides (Precedence fix) */
  @media (min-width: 700px) {
    .layout {
      grid-template-columns: 1fr 2fr;
      align-items: start;
      gap: 24px;
    }
    .chart-panel {
      position: sticky;
      top: 24px;
      order: 0;
    }
  }
`;
